/**
 * Display formatters shared by the MCAP log list, its table cells and the
 * detail modal.
 */
import { formatShortDateTime as sharedFormatShortDateTime } from "shared/utils/datetime";

/**
 * Format bytes to human-readable format
 */
export const formatBytes = (bytes) => {
  if (bytes == null || !Number.isFinite(bytes) || bytes < 0) return "N/A";
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
};

/**
 * Format duration to human-readable format
 */
export const formatDuration = (seconds) => {
  if (seconds == null || !Number.isFinite(seconds)) return "N/A";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  } else if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  } else {
    return `${secs}s`;
  }
};

/**
 * Format a count with thousands separators, tolerating null/undefined.
 */
export const formatCount = (count) =>
  Number.isFinite(count) ? count.toLocaleString() : "0";

/**
 * Compact date for the secondary line of a table cell: drops the seconds,
 * which are noise at list density. Timezone-aware values are shown in the
 * user's local time; naive values keep their original wall clock.
 */
export const formatShortDateTime = (value) => sharedFormatShortDateTime(value, "N/A");
